import { useState, useEffect } from "react";
import axios, { AxiosResponse } from "axios";
import { apibaseurl, jwttoken } from '../environment'


interface ApiOptions {
    method?: "GET" | "POST" | "DELETE";
    payload?: Record<string, any> | null;
    autoCall?: boolean;
    dependencies?: any[];
}

interface UseApiResult<T> {
    data: T | null;
    loading: boolean;
    error: any;
    callApi: (payload?: Record<string, any>) => Promise<T>;
}




function useApi<T = any>(
    endpoint: string,
    {
        method = "GET",
        payload = null,
        autoCall = true,
        dependencies = [],
    }: ApiOptions = {}
): UseApiResult<T> {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState<boolean>(autoCall);
    const [error, setError] = useState<any>(null);
    const callApi = async (customPayload = payload): Promise<T> => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${jwttoken}`,
                    "Content-Type": "application/json", // <-- ADD THIS
                },
                data: method === "DELETE" ? customPayload : undefined,
            };

            // ✅ Log the outgoing request
            console.log("Calling API:", {
                url: `${apibaseurl}${endpoint}`,
                method,
                payload: customPayload,
                config,
            });

            let response: AxiosResponse<any>;

            if (method === "POST") {
                response = await axios.post(
                    `${apibaseurl}${endpoint}`,
                    customPayload,
                    config
                );
            } else if (method === "DELETE") {
                response = await axios.delete(`${apibaseurl}${endpoint}`, config);
            } else {
                response = await axios.get(`${apibaseurl}${endpoint}`, config);
            }

            setData(response.data);
            setError(null);
            return response.data;
        } catch (err) {
            console.error("API Error:", err);
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (autoCall) {
            callApi();
        }
    }, dependencies);

    return { data, loading, error, callApi };
}

export default useApi;

